/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.fk02

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.fk02Routing(app: App): Navigo {
    return on("/polecenie_przelewu_fk_02_nowy/:token", { params ->
        Model.nowy(stringProperty(params, "token"), app)
    }).on("/polecenie_przelewu_fk_02_edycja/:token", { params ->
        Model.edycja(stringProperty(params, "token"), app)
    })
}
